import React, { useState } from "react";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

import { Link } from "react-router-dom";
import LoadingBox from "./LoadingBox";
import MessageBox from "./MessageBox";
import moment from "moment/moment";

import { useNews } from "../features/useNews";
import { replace_string, server_django } from "../util";
import SpinnerMini from "../UI/SpinnerMini";

const News = ({ newsConfig }) => {
  const [items, setItems] = useState(2);
  const [responsive, setResponsive] = useState({
    0: {
      items: 1,
    },
    450: {
      items: 2,
    },
    600: {
      items: 2,
    },
    1000: {
      items: 2,
    },
  });

  const { news, isLoading, error } = useNews(newsConfig);

  if (isLoading) return <SpinnerMini />;
  if (error) return <MessageBox>{error.message}</MessageBox>;

  return (
    <div id="news">
      <div className="text-left">
        <Link exact to="/newsPage">
          <p className="heading3">News</p>
        </Link>
      </div>

      <div className="newsContainer">
        {news.length > 0 && (
          <OwlCarousel
            className="owl-theme"
            loop
            margin={10}
            autoplay={true}
            responsive={responsive}
          >
            {news.map((newsList) => {
              return (
                <div className="item" key={newsList.id}>
                  <div className="card">
                    <img
                      className="img-fuild"
                      src={newsList.headerImage?.replace(
                        replace_string,
                        server_django
                      )}
                      alt={newsList.headerImage?.replace(
                        replace_string,
                        server_django
                      )}
                    ></img>
                    <div className="card-body">
                      <div className="newsFooter">
                        <div className="newsHeadlines">
                          <Link exact to={"/news/" + newsList.id}>
                            <p className="heading5">{newsList.headline}</p>
                          </Link>
                          <p className="publsihDate">
                            {moment(newsList.newsDate, "YYYY-MM-DD").format(
                              "LL"
                            )}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </OwlCarousel>
        )}
      </div>
    </div>
  );
};

export default News;
